import { createContext } from 'react';

export const CarouselContext = createContext(false);
